// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Admin_protectedPanel__3WcfQ {\n  min-width: 0;\n}\n\n@media (min-width: 992px) {\n  .Admin_protectedPanel__3WcfQ {\n    transition: width 0.2s ease-out;\n    width: calc(100% - 4rem);\n  }\n\n  .Admin_protectedPanelExpanded__IoTdm {\n    width: calc(100% - 16.5rem);\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"protectedPanel": "Admin_protectedPanel__3WcfQ",
	"protectedPanelExpanded": "Admin_protectedPanelExpanded__IoTdm"
};
module.exports = exports;
